/* Ecademy - interactive bits: curriculum tabs, module accordion, reveal, intro video */

(function () {
  'use strict';

  /* Curriculum: tab switch (Basic ↔ Pro) */
  document.querySelectorAll('[data-ec-curr]').forEach(function (root) {
    var tabs   = root.querySelectorAll('[data-ec-tab]');
    var panels = root.querySelectorAll('[data-ec-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-ec-tab');
        tabs.forEach(function (t) { t.classList.toggle('ec-curr__tab--active', t === tab); });
        panels.forEach(function (p) {
          p.classList.toggle('ec-curr__panel--active', p.getAttribute('data-ec-panel') === target);
        });
      });
    });
  });

  /* Module accordion */
  document.querySelectorAll('.ec-module__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var module = btn.closest('.ec-module');
      var open = module.getAttribute('aria-expanded') === 'true';
      module.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Intro video - click poster, swap to inline embed (autoplay) */
  function buildEmbed(rawUrl) {
    if (!rawUrl) return '';
    var url = rawUrl.trim();

    var ytMatch = url.match(/(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);
    if (ytMatch) {
      return '<iframe src="https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0" title="Видео представяне" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    }
    var vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vimeoMatch) {
      return '<iframe src="https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1" title="Видео представяне" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    }
    if (/\.(mp4|webm|ogg)(\?.*)?$/i.test(url)) {
      return '<video controls autoplay playsinline src="' + url + '"></video>';
    }
    return '<iframe src="' + url + '" title="Видео представяне" allow="autoplay; fullscreen" allowfullscreen></iframe>';
  }

  document.querySelectorAll('[data-ec-intro-video]').forEach(function (root) {
    var url   = root.getAttribute('data-ec-intro-video');
    var embed = root.querySelector('[data-ec-intro-embed]');
    var poster = root.querySelector('[data-ec-intro-poster]');
    if (!url || !embed || !poster) return;
    poster.addEventListener('click', function () {
      embed.innerHTML = buildEmbed(url);
      root.classList.add('is-playing');
    });
  });

  /* ═══════════════════════════════════════════════════════════════ */
  /* ═══ Animation pack v2: scroll-progress, count-up, magnetic, ═══ */
  /* ═══ auto-stagger, count-up on intersection.                 ═══ */
  /* ═══════════════════════════════════════════════════════════════ */

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ─── Scroll-progress bar at top of page ─── */
  if (!prefersReducedMotion && !document.querySelector('.ec-scroll-progress')) {
    var bar = document.createElement('div');
    bar.className = 'ec-scroll-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function updateProgress() {
      var h = document.documentElement;
      var scrollTop = h.scrollTop || document.body.scrollTop;
      var max = (h.scrollHeight || document.body.scrollHeight) - h.clientHeight;
      var pct = max > 0 ? Math.min(100, Math.max(0, (scrollTop / max) * 100)) : 0;
      bar.style.width = pct + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(updateProgress); ticking = true; }
    }, { passive: true });
    updateProgress();
  }

  /* ─── Count-up: ONLY for elements explicitly tagged with data-ec-counter.
        Keep text visible until the animation actually starts (safe fallback). ─── */
  function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }
  function animateCount(el) {
    var targetText = el.getAttribute('data-ec-counter') || el.textContent.trim();
    var m = String(targetText).match(/^([^\d-]*)(-?[\d\s.,]+)(.*)$/);
    if (!m) return;
    var prefix = m[1] || '';
    var rawNum = m[2].replace(/\s/g, '').replace(',', '.');
    var num = parseFloat(rawNum);
    if (!isFinite(num)) return;
    var suffix = m[3] || '';
    var hasDecimal = rawNum.indexOf('.') !== -1;
    var startTime = null;
    var duration = 1400;
    function step(ts) {
      if (!startTime) startTime = ts;
      var p = Math.min(1, (ts - startTime) / duration);
      var v = num * easeOutQuart(p);
      var display = hasDecimal ? v.toFixed(1) : Math.round(v).toLocaleString('bg-BG');
      el.textContent = prefix + display + suffix;
      if (p < 1) window.requestAnimationFrame(step);
      else el.textContent = targetText;
    }
    window.requestAnimationFrame(step);
  }

  var counterTargets = document.querySelectorAll('[data-ec-counter]');
  if (counterTargets.length && !prefersReducedMotion && 'IntersectionObserver' in window) {
    var counterIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          animateCount(e.target);
          counterIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    counterTargets.forEach(function (t) { counterIO.observe(t); });
  }

  /* ─── Deferred-autoplay video: start playback only when section enters viewport ─── */
  if ('IntersectionObserver' in window) {
    var deferIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var node = e.target;
        // Iframes (YouTube / Vimeo): swap src to the autoplay variant
        if (node.tagName === 'IFRAME') {
          var autoplaySrc = node.getAttribute('data-ec-defer-autoplay');
          if (autoplaySrc && node.src !== autoplaySrc) {
            node.src = autoplaySrc;
          }
        } else if (node.tagName === 'VIDEO') {
          // HTML5 video: just call play()
          try { node.play(); } catch (_) {}
        }
        deferIO.unobserve(node);
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });

    document.querySelectorAll('iframe[data-ec-defer-autoplay], video[data-ec-defer-autoplay-video]')
      .forEach(function (el) { deferIO.observe(el); });
  }

  /* ─── Hero Card 1: foreground carousel ─── */
  document.querySelectorAll('[data-ec-hero-slider]').forEach(function (slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-ec-hero-slide]'));
    if (slides.length <= 1) return; // no rotation needed for a single slide

    var dotsHost = slider.querySelector('[data-ec-hero-dots]');
    var autoplay = slider.getAttribute('data-autoplay') !== '0';
    var interval = parseInt(slider.getAttribute('data-interval'), 10) || 5;
    var current = 0;
    var timerId = null;

    // Build dots
    if (dotsHost) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Слайд ' + (i + 1));
        if (i === 0) b.classList.add('is-active');
        b.addEventListener('click', function () { go(i, true); });
        dotsHost.appendChild(b);
      });
    }
    var dots = dotsHost ? Array.prototype.slice.call(dotsHost.children) : [];

    function go(idx, fromUser) {
      idx = ((idx % slides.length) + slides.length) % slides.length;
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = idx;
      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
      if (fromUser) restartTimer();
    }
    function next() { go(current + 1); }
    function startTimer() {
      if (!autoplay || prefersReducedMotion) return;
      stopTimer();
      timerId = setInterval(next, interval * 1000);
    }
    function stopTimer() { if (timerId) { clearInterval(timerId); timerId = null; } }
    function restartTimer() { stopTimer(); startTimer(); }

    // Pause on hover
    slider.addEventListener('mouseenter', stopTimer);
    slider.addEventListener('mouseleave', startTimer);

    // Touch swipe (mobile)
    var touchStartX = null;
    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      stopTimer();
    }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (touchStartX == null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        if (dx < 0) go(current + 1, true);
        else go(current - 1, true);
      } else {
        startTimer();
      }
      touchStartX = null;
    });

    // Pause when not visible (saves CPU)
    if ('IntersectionObserver' in window) {
      var visIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) startTimer();
          else stopTimer();
        });
      }, { threshold: 0.2 });
      visIO.observe(slider);
    } else {
      startTimer();
    }
  });

  /* ─── Video testimonials: play/pause on scroll + tap-to-unmute ─── */
  (function () {
    var vtestVideos = document.querySelectorAll('[data-ec-vtest-video]');
    if (!vtestVideos.length) return;

    // Play only when in view, pause when out — unless the user manually paused
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && !v.__ecUserPaused) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
          else { v.pause(); }
        });
      }, { threshold: 0.4 });
      vtestVideos.forEach(function (v) { vio.observe(v); });
    }

    // Play/pause buttons + seek sliders
    document.querySelectorAll('[data-ec-vtest-controls]').forEach(function (ctrl) {
      var media = ctrl.closest('.ec-vtest__media');
      var video = media && media.querySelector('[data-ec-vtest-video]');
      if (!video) return;
      var btn  = ctrl.querySelector('[data-ec-vtest-playpause]');
      var seek = ctrl.querySelector('[data-ec-vtest-seek]');
      var iconPlay  = btn && btn.querySelector('.ec-vtest__icon-play');
      var iconPause = btn && btn.querySelector('.ec-vtest__icon-pause');

      function syncIcon() {
        var paused = video.paused;
        if (iconPlay)  iconPlay.hidden  = !paused;
        if (iconPause) iconPause.hidden = paused;
        if (btn) btn.setAttribute('aria-label', paused ? 'Пусни' : 'Пауза');
      }

      if (btn) {
        btn.addEventListener('click', function () {
          if (video.paused) {
            video.__ecUserPaused = false;
            var p = video.play(); if (p && p.catch) p.catch(function(){});
          } else {
            video.__ecUserPaused = true;
            video.pause();
          }
          syncIcon();
        });
      }

      video.addEventListener('play', syncIcon);
      video.addEventListener('pause', syncIcon);

      // Update seek as video plays
      video.addEventListener('timeupdate', function () {
        if (!video.duration || isNaN(video.duration)) return;
        var pct = (video.currentTime / video.duration) * 100;
        if (seek && !seek.__ecDragging) {
          seek.value = pct;
          seek.style.setProperty('--seek-pct', pct + '%');
        }
      });

      // Scrub
      if (seek) {
        seek.addEventListener('input', function () {
          seek.__ecDragging = true;
          seek.style.setProperty('--seek-pct', seek.value + '%');
          if (video.duration) video.currentTime = (seek.value / 100) * video.duration;
        });
        seek.addEventListener('change', function () { seek.__ecDragging = false; });
        // Don't let dragging the slider toggle play state via bubbling
        seek.addEventListener('click', function (e) { e.stopPropagation(); });
      }

      syncIcon();
    });

    // Unmute toggle — unmuting one mutes all others
    document.querySelectorAll('[data-ec-vtest-unmute]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var media = btn.closest('.ec-vtest__media');
        var video = media && media.querySelector('[data-ec-vtest-video]');
        if (!video) return;
        var willUnmute = video.muted;
        if (willUnmute) {
          // mute every other video first
          vtestVideos.forEach(function (other) {
            if (other !== video) {
              other.muted = true;
              var ob = other.closest('.ec-vtest__media');
              if (ob) { var obtn = ob.querySelector('[data-ec-vtest-unmute]'); if (obtn) setUnmuteIcon(obtn, false); }
            }
          });
        }
        video.muted = !video.muted;
        if (!video.muted) { var pr = video.play(); if (pr && pr.catch) pr.catch(function(){}); }
        setUnmuteIcon(btn, !video.muted);
      });
    });

    function setUnmuteIcon(btn, soundOn) {
      var mutedIcon = btn.querySelector('.ec-vtest__icon-muted');
      var soundIcon = btn.querySelector('.ec-vtest__icon-sound');
      if (mutedIcon) mutedIcon.hidden = soundOn;
      if (soundIcon) soundIcon.hidden = !soundOn;
      btn.setAttribute('aria-label', soundOn ? 'Изключи звук' : 'Включи звук');
    }
  })();

  /* ─── Magnetic hover for primary CTAs (subtle pull toward cursor) ─── */
  if (!prefersReducedMotion && window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.btn-primary').forEach(function (btn) {
      var rect;
      btn.addEventListener('mouseenter', function () { rect = btn.getBoundingClientRect(); });
      btn.addEventListener('mousemove', function (e) {
        if (!rect) rect = btn.getBoundingClientRect();
        var x = e.clientX - (rect.left + rect.width / 2);
        var y = e.clientY - (rect.top + rect.height / 2);
        btn.style.transform = 'translate(' + (x * 0.12) + 'px, ' + (y * 0.18) + 'px) translateY(-2px) scale(1.02)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
        rect = null;
      });
    });
  }
})();
